import { useEffect, useState } from "react";

const CLIP_DURATIONS = { noel: 9800, epiphanie: 8800, chandeleur: 9800 };
const CLIP_START_DELAY = 4650;
const FLAKE_SIZES = [4, 5, 6, 7, 8, 10];

export function Snowfall({ count = 40, persistent = false }) {
  const flakes = Array.from({ length: count }, () => ({
    x: (Math.random() * 100).toFixed(1),
    t: (5 + Math.random() * 6).toFixed(1),
    d: (Math.random() * 6).toFixed(1),
    sway: `${(Math.random() * 10 - 5).toFixed(1)}vw`,
    s: FLAKE_SIZES[Math.floor(Math.random() * FLAKE_SIZES.length)],
    o: (0.55 + Math.random() * 0.45).toFixed(2),
  }));
  return (
    <div className={`snowfall${persistent ? " snowfall-fixed" : ""}`} data-testid={persistent ? "snowfall-site" : "snowfall-clip"} aria-hidden="true">
      {flakes.map((f, i) => (
        <span key={i} className="snow-flake" style={{ left: `${f.x}vw`, "--t": `${f.t}s`, "--d": `${f.d}s`, "--sway": f.sway, "--s": `${f.s}px`, opacity: f.o }} />
      ))}
    </div>
  );
}

export default function SeasonalClip({ mode }) {
  const [stage, setStage] = useState("waiting");

  useEffect(() => {
    const t1 = setTimeout(() => setStage("playing"), CLIP_START_DELAY);
    const t2 = setTimeout(() => setStage("done"), CLIP_START_DELAY + (CLIP_DURATIONS[mode] || 8800));
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [mode]);

  if (stage !== "playing" || !CLIP_DURATIONS[mode]) return null;

  return (
    <div className={`seasonal-clip clip-${mode}`} data-testid={`seasonal-clip-${mode}`} aria-hidden="true">
      {mode === "noel" && (
        <>
          <img src="/assets/seasonal/noel-village.jpg" alt="" className="clip-bg" />
          <div className="clip-sleigh-real-wrap" data-testid="clip-sleigh-real">
            <img src="/assets/seasonal/santa-real.png" alt="" className="clip-sleigh-real" />
            <span className="clip-reindeer-wink" />
          </div>
          <div className="clip-bubble clip-bubble-noel">Oh oh oh&nbsp;!</div>
          <Snowfall count={90} />
        </>
      )}
      {mode === "epiphanie" && (
        <>
          <img src="/assets/seasonal/epiphanie-scene.jpg" alt="" className="clip-bg" />
          <img src="/assets/seasonal/galette-part.png" alt="" className="clip-galette-slice" />
          <div className="clip-bubble clip-bubble-epiphanie">On vous offre une part&nbsp;!</div>
        </>
      )}
      {mode === "chandeleur" && (
        <>
          <img src="/assets/seasonal/chandeleur-cuisine.jpg" alt="" className="clip-bg clip-scene-1" />
          <img src="/assets/seasonal/chandeleur-gouter.jpg" alt="" className="clip-bg clip-scene-2" />
          <div className="clip-pan" />
          <div className="clip-crepe" />
        </>
      )}
    </div>
  );
}
